import * as SG from 'styles';

import { SizeQtyPrice } from 'types/api/product.type';

import { Headline } from 'components/Headline';
import { Table } from 'components/Table';

import { useTechnicalData } from './TechnicalData.hooks';
import * as S from './TechnicalData.styles';

type TechnicalDataProps = {
  desc: string;
  accessories: string[];
  technologies: string[];
  sizes?: SizeQtyPrice[];
  scale?: string;
};

export function TechnicalData(props: TechnicalDataProps): React.ReactElement {
  const { desc, accessories, sizes = [], technologies, scale = undefined } = props;

  const { t, columns, accessoriesComponents, imageComponents } = useTechnicalData({
    accessories,
    technologies,
    scale,
  });

  return (
    <S.Container>
      <SG.Inner>
        <S.FlexContainer>
          <S.Wrapper>
            <S.Title textTransform="uppercase" color="gray" scale="xl3">
              {t('catalogue.technicalData')}
            </S.Title>

            <S.TextBlock>
              <Headline textTransform="isFirstLetterUppercase" color="gray" scale="lg">
                {t('catalogue.description')}
              </Headline>

              <Headline fontFamily="LFT Zeno" color="borderLight" scale="s" isWrapped>
                {desc}
              </Headline>
            </S.TextBlock>

            <S.TextBlock>
              <Headline textTransform="isFirstLetterUppercase" color="gray" scale="lg">
                {t('catalogue.accessories')}
              </Headline>

              {accessoriesComponents}
            </S.TextBlock>
          </S.Wrapper>

          {sizes?.length > 0 ? (
            <S.Wrapper>
              <S.Title textTransform="uppercase" color="gray" scale="xl3">
                {t('catalogue.sizes')}
              </S.Title>

              <Table motive="secondary" columns={columns} data={sizes} />
            </S.Wrapper>
          ) : null}

          <S.Wrapper>
            <S.Title textTransform="uppercase" color="gray" scale="xl3">
              {t('catalogue.technologies')}
            </S.Title>

            <S.Technologies>{imageComponents}</S.Technologies>
          </S.Wrapper>
        </S.FlexContainer>
      </SG.Inner>
    </S.Container>
  );
}
